<template>
  <span>
    <template v-if="headers.customSort">
      <span class="cursor-pointer" @click="handleSort(headers.value)">
        <span class="pr-2"> {{ headers.text }} </span>
        <template v-if="sortBy === headers.value">
          <template v-if="orderBy === OrderByDesc">
            <em class="fas fa-chevron-down"></em>
          </template>
          <template v-else>
            <em class="fas fa-chevron-up"></em>
          </template>
        </template>
        <template v-else>
          <em class="fas fa-chevron-down"></em>
        </template>
      </span>
    </template>
    <template v-else>
      <span> {{ headers.text }} </span>
    </template>
  </span>
</template>

<script>
import { ORDER_BY } from '@/constants/orderBy.js'
export default {
  props: ['headers', 'sortBy', 'orderBy'],
  computed: {
    OrderByDesc() {
      return ORDER_BY.DESC
    },
    orderByAsc() {
      return ORDER_BY.ASC
    }
  },
  methods: {
    handleSort(value) {
      if (value !== this.sortBy) {
        this.$emit('update:sortBy', value)
        this.$emit('update:orderBy', this.OrderByDesc)
      } else {
        let orderBy = this.orderBy === this.OrderByDesc ? this.orderByAsc : this.OrderByDesc
        this.$emit('update:sortBy', value)
        this.$emit('update:orderBy', orderBy)
      }
      this.$emit('onSort')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/HeaderTableWithSort.vue